/* eslint-disable import/prefer-default-export */
export const LOAN_STATUS = {
  PENDING: 0,
  DECLINED: 1,
  ACTIVE: 2,
  OVERDUE: 3,
  SETTLED: 4,
};

export const LOAN_AMOUNT_STEP = 1;
export const MAX_LOAN_PERCENTAGE = 0.5;

export const LTV = {
  LTV_10: 'interest_rate_ltv_10',
  LTV_25: 'interest_rate_ltv_25',
  LTV_33: 'interest_rate_ltv_33',
  LTV_50: 'interest_rate_ltv_50',
};

export const LTV_PERCENTAGES = {
  interest_rate_ltv_10: 10,
  interest_rate_ltv_25: 25,
  interest_rate_ltv_33: 33,
  interest_rate_ltv_50: 50,
};

export const COLLATERAL_MARGIN_PERCENTAGE = 3;

export const MODAL_SCREENS = {
  ADD_LOAN: 'ADD_LOAN',
  ACH_ACCOUNT_DETAILS: 'ACH_ACCOUNT_DETAILS',
  LOAN_DETAILS: 'LOAN_DETAILS',
  AVERAGE_INCOME: 'AVERAGE_INCOME',
  LOAN_APPROVED: 'LOAN_APPROVED',
  REPAY_LOAN: 'REPAY_LOAN',
  WALLETS: 'WALLETS',
  LOAN_OFFER: 'LOAN_OFFER',
  LOAN_TERMS: 'LOAN_TERMS',
  LOAN_MORE_COLLATERAL: 'LOAN_MORE_COLLATERAL',
  PAY_INTEREST: 'PAY_INTEREST',
  ADD_EXTRA_COLLATERAL: 'ADD_EXTRA_COLLATERAL',
  ADD_MORE_COLLATERAL: 'add_more_collateral',
  PROCEED_WITH_PAYMENT: 'proceed_with_payment',
  DETAILS_INFO: 'details_info',
  PAYOUT_DETAILS_INFO: 'payout_details_info',
  PURPOSE_OF_LOAN: 'PURPOSE_OF_LOAN',
  REVIEWING_LOAN_APPLICATION: 'REVIEWING_LOAN_APPLICATION',
};
